import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getSertifikatContent = createAsyncThunk('/sertifikat/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompanyCertFile/${userId}`, {})
    return response.data;
})

export const sertifikatSlice = createSlice({
    name: 'sertifikat',
    initialState: {
        isLoading: false,
        sertifikat : []
    },
    reducers: {


        addNewSertifikat: (state, action) => {
            let {newSertifikatObj} = action.payload
            state.sertifikat = [...state.sertifikat, newSertifikatObj]
        },

        deleteSertifikat: (state, action) => {
            let {index} = action.payload
            state.sertifikat.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getSertifikatContent.pending]: state => {
			state.isLoading = true
		},
        [getSertifikatContent.fulfilled]: (state, action) => {
            state.sertifikat = action.payload.data
			state.isLoading = false
		},
        [getSertifikatContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {           
        builder
        .addCase(getSertifikatContent.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getSertifikatContent.fulfilled, (state, action) => {
            state.sertifikat = action.payload.data;
            state.isLoading = false;
        })
        .addCase(getSertifikatContent.rejected, (state) => {
            state.isLoading = false;
        });
    }       
})

export const { addNewSertifikat, deleteSertifikat } = sertifikatSlice.actions

export default sertifikatSlice.reducer